module.exports = __webpack_public_path__ + "f8b6a92eba7cd8b8a8287167560d1996.png";